import { render } from "./BatterDrillView.vue?vue&type=template&id=50ae8296&scoped=true"
import script from "./BatterDrillView.vue?vue&type=script&lang=js"
export * from "./BatterDrillView.vue?vue&type=script&lang=js"

import "./BatterDrillView.vue?vue&type=style&index=0&id=50ae8296&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ae8296"]])

export default __exports__